import { TabPanel } from "@commonlibs";
import clsx from "clsx";
import { MainTabsPanelProps } from "./MainTabs.types";

function MainTabsPanel({ className, tabs, ...rest }: MainTabsPanelProps) {
    return (
        <>
            {tabs.map((tab, index) => (
                // skipcq
                <TabPanel index={index} key={index} {...rest} className={clsx("main-tabs-panel", className)}>
                    {tab.children}
                </TabPanel>
            ))}
        </>
    );
}

export default MainTabsPanel;
